import React, { useContext } from 'react';
import tw from 'twin.macro';

import Image from '@/assets/images/hiw_img.webp';
import DIcon from '@/assets/images/icons/DIcon';
import GBIcon from '@/assets/images/icons/GBIcon';
import { BigTitle, SubTitle } from '@/components';
import { DeviceInfoContext } from '@/contexts/device-info-context';
function InvestHowItWorks() {
  const { isMobile, isTablet } = useContext(DeviceInfoContext);
  return (
    <div>
      <BigTitle text={'Как это работает'} twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`} />
      <SubTitle
        text={
          'Брокерский счёт во Freedom Finance Global PLC состоит из двух частей — торгового и накопительного счетов:'
        }
      />
      <div tw='sm:grid grid-cols-[2fr 1fr] gap-5 mt-5'>
        <div tw='flex flex-col gap-5'>
          <div tw='bg-[#444444] flex p-5 rounded-2xl'>
            <GBIcon width={isMobile ? 150 : 100} />
            <div tw='-mt-1 h-full'>
              <SubTitle text={'Торговый счёт'} variant={'bold'} />
              <SubTitle
                text={'для покупки и продажи акций международных компаний: Amazon, Facebook, Tesla и тысячи других.'}
                twStyle={tw`xl:text-s18 md:text-s14 sm:text-s14`}
              />
            </div>
          </div>
          <div tw='bg-[#444444] flex sm:gap-0 p-5 rounded-2xl h-full'>
            <DIcon width={isMobile ? 300 : 200} />
            <div tw='-mt-1'>
              <SubTitle text={'Накопительный счёт'} variant={'bold'} />
              <SubTitle
                text={
                  'для хранения денег. Карта инвестора отражает его баланс. D-счёт можно использовать для оплаты покупок, переводов, пополнения или вывода денег с торгового счёта в долларах, тенге, евро и рублях.'
                }
                twStyle={tw`xl:text-s18 md:text-s14 sm:text-s14`}
              />
            </div>
          </div>
        </div>
        <div tw='bg-[#444444] rounded-2xl flex mt-5 sm:mt-0 items-end'>
          <img src={Image} alt='' tw=' w-full' />
        </div>
      </div>
    </div>
  );
}

export default InvestHowItWorks;
